import type { CSSProperties } from 'react';
import { cn } from '@/shared/lib/cn';

/**
 * Пульсирующая заглушка на время загрузки.
 *
 * Заливка — `--color-glass-3` (Steel Border), а не `--color-glass`: последний
 * равен чистому белому, то есть цвету самой карточки, и скелет на ней был
 * невидим — оставались пустые белые прямоугольники.
 */
export function Skeleton({ className, style }: { className?: string; style?: CSSProperties }) {
  return (
    <div
      aria-hidden="true"
      style={style}
      className={cn('animate-pulse rounded-md bg-glass-3', className)}
    />
  );
}
